(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sms-language-server", [], factory);
	else if(typeof exports === 'object')
		exports["sms-language-server"] = factory();
	else
		root["sms-language-server"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 